module.exports = __webpack_public_path__ + "img/momturn.4e851678.jpg";